import { useTheme } from "styled-components";
import Layout from "../../../../components/layout/Layout";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import { StyledAltButton, StyledButton } from "../../../../styles/ButtonStyles";
import { useFrontofficeContext } from "../../../../context/FrontofficeContext";
import { useAuthContext } from "../../../../context/AuthContext";

function StartPageView() {
  const theme = useTheme();
  const authContext = useAuthContext();
  const { updatePage, terminal } = useFrontofficeContext();
  const { translateEntity, translate } = useLanguageContext();

  return (
    <Layout
      layoutData={terminal?.layout}
      content={
        <StyledFlexColumn style={{ gap: theme.spacing.large }}>
          <StyledFlexColumn>
            {terminal?.show_sign_in_button && (
              <StyledButton onClick={() => updatePage("sign_in")}>
                {translate("eva.frontoffice.pages.sign_in.label")}
              </StyledButton>
            )}

            {terminal?.show_sign_out_button && (
              <StyledButton onClick={() => updatePage("sign_out")}>
                {translate("eva.frontoffice.pages.sign_out.label")}
              </StyledButton>
            )}
          </StyledFlexColumn>

          {terminal?.buttons?.length > 0 && (
            <StyledFlexColumn>
              {terminal?.buttons
                ?.sort((a, b) => a.order - b.order)
                ?.map((button) => (
                  <StyledAltButton
                    key={button.id}
                    onClick={() =>
                      updatePage("button", { buttonId: button.id })
                    }
                  >
                    {translateEntity(button, "title")}
                  </StyledAltButton>
                ))}
            </StyledFlexColumn>
          )}

          {authContext.auth.impersonating && (
            <StyledAltButton onClick={() => authContext.logout()}>
              {translate("eva.frontoffice.general.back")}
            </StyledAltButton>
          )}
        </StyledFlexColumn>
      }
    />
  );
}

export default StartPageView;
